import qs from "query-string";

// API_HOST is baked in at build time from REACT_APP_API_HOST. When empty, calls go same-origin.
// CloudFront-served deployments must set REACT_APP_API_HOST to the absolute API base URL.
const API_HOST = process.env.REACT_APP_API_HOST || "";
const API_ROUTE_PREFIX = `${API_HOST}/api`;
const DEFAULT_API_VERSION = 1;

export function getApiUrl(version) {
    return `${API_ROUTE_PREFIX}/v${version || DEFAULT_API_VERSION}`;
}

export const wevosUrl = (teamId, params) =>
    `${getApiUrl()}/teams/${teamId}/wevos${
        !params ? "" : `?${qs.stringify(params)}`
    }`;



// WEBPACK FOOTER //
// ./src/helpers/api.js